__turbopack_context__.v({
  "grid": "media-grid-module-scss-module__2qJZeG__grid",
});
